import { render, staticRenderFns } from "./SaveTask.vue?vue&type=template&id=4b743ff0&scoped=true&"
import script from "./SaveTask.vue?vue&type=script&lang=js&"
export * from "./SaveTask.vue?vue&type=script&lang=js&"
import style0 from "./SaveTask.vue?vue&type=style&index=0&id=4b743ff0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b743ff0",
  null
  
)

export default component.exports